import { render } from "./Appbottomnav.vue?vue&type=template&id=5b2b0f84&scoped=true"
import script from "./Appbottomnav.vue?vue&type=script&lang=js"
export * from "./Appbottomnav.vue?vue&type=script&lang=js"

import "./Appbottomnav.vue?vue&type=style&index=0&id=5b2b0f84&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/.store/vue-loader@17.1.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b2b0f84"]])

export default __exports__